import { render, staticRenderFns } from "./Contrato.vue?vue&type=template&id=12085f37&scoped=true"
import script from "./Contrato.vue?vue&type=script&lang=js"
export * from "./Contrato.vue?vue&type=script&lang=js"
import style0 from "./Contrato.vue?vue&type=style&index=0&id=12085f37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12085f37",
  null
  
)

export default component.exports